var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormProvider, useForm } from "react-hook-form";
import { Button, Flex } from "@gravity-ui/uikit";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormTextInput } from "@/components/formUi";
import { validationSchema } from "./formRules";
export var UserEditForm = function (props) {
    var formMethods = useForm({
        defaultValues: props.data,
        resolver: yupResolver(validationSchema),
    });
    var control = formMethods.control, handleSubmit = formMethods.handleSubmit, formState = formMethods.formState, reset = formMethods.reset;
    var submitHandler = function (event) {
        handleSubmit(props.onSave)(event);
    };
    var resetFormHandler = function () {
        reset();
        props.onCancel();
    };
    return (_jsxs(FormProvider, __assign({}, formMethods, { children: [_jsx(FormTextInput, { control: control, name: "username", placeholder: "\u0418\u043C\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F", autoComplete: "off" }), _jsxs(Flex, { gap: 4, children: [_jsx("form", { onSubmit: submitHandler, children: _jsx(Button, { view: "action", type: "submit", disabled: !formState.isDirty, children: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C" }) }), _jsx(Button, { view: "normal", disabled: !formState.isDirty, onClick: resetFormHandler, children: "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C" })] })] })));
};
